const BODY_PARTS = {
    front: [
        { key: 'shoulder-l', shape: 'ellipse', cx: 11, cy: 28, rx: 8, ry: 6 },
        { key: 'shoulder-r', shape: 'ellipse', cx: 53, cy: 28, rx: 8, ry: 6 },
        { key: 'arm-l', shape: 'rect', x: 4, y: 27, width: 11, height: 22, rx: 4 },
        { key: 'arm-r', shape: 'rect', x: 49, y: 27, width: 11, height: 22, rx: 4 },
        { key: 'chest', shape: 'rect', x: 19, y: 22, width: 26, height: 21, rx: 3 },
        { key: 'abs', shape: 'rect', x: 19, y: 43, width: 26, height: 18, rx: 3 },
        { key: 'hip', shape: 'rect', x: 20, y: 61, width: 24, height: 10, rx: 3 },
        { key: 'leg-l', shape: 'rect', x: 19, y: 71, width: 11, height: 32, rx: 4 },
        { key: 'leg-r', shape: 'rect', x: 34, y: 71, width: 11, height: 32, rx: 4 },
        { key: 'calf-l', shape: 'rect', x: 19, y: 105, width: 10, height: 24, rx: 4 },
        { key: 'calf-r', shape: 'rect', x: 35, y: 105, width: 10, height: 24, rx: 4 },
    ],
    back: [
        { key: 'shoulder-l', shape: 'ellipse', cx: 11, cy: 28, rx: 8, ry: 6 },
        { key: 'shoulder-r', shape: 'ellipse', cx: 53, cy: 28, rx: 8, ry: 6 },
        { key: 'arm-l', shape: 'rect', x: 4, y: 27, width: 11, height: 22, rx: 4 },
        { key: 'arm-r', shape: 'rect', x: 49, y: 27, width: 11, height: 22, rx: 4 },
        { key: 'upper-back', shape: 'rect', x: 19, y: 22, width: 26, height: 18, rx: 3 },
        { key: 'lower-back', shape: 'rect', x: 19, y: 40, width: 26, height: 14, rx: 3 },
        { key: 'glute', shape: 'rect', x: 20, y: 54, width: 24, height: 17, rx: 3 },
        { key: 'leg-l', shape: 'rect', x: 19, y: 71, width: 11, height: 32, rx: 4 },
        { key: 'leg-r', shape: 'rect', x: 34, y: 71, width: 11, height: 32, rx: 4 },
        { key: 'calf-l', shape: 'rect', x: 19, y: 105, width: 10, height: 24, rx: 4 },
        { key: 'calf-r', shape: 'rect', x: 35, y: 105, width: 10, height: 24, rx: 4 },
    ],
};

const MUSCLE_MAP = {
    '가슴': { front: ['chest', 'arm-l', 'arm-r'], back: [] },
    '상부가슴': { front: ['chest', 'shoulder-l', 'shoulder-r'], back: [] },
    '중부가슴': { front: ['chest'], back: [] },
    '하부가슴': { front: ['chest', 'abs'], back: [] },
    '등': { front: [], back: ['upper-back', 'lower-back', 'arm-l', 'arm-r'] },
    '광배근': { front: [], back: ['upper-back', 'lower-back', 'arm-l', 'arm-r'] },
    '승모근': { front: ['shoulder-l', 'shoulder-r'], back: ['upper-back', 'shoulder-l', 'shoulder-r'] },
    '능형근': { front: [], back: ['upper-back'] },
    '척추기립근': { front: [], back: ['lower-back'] },
    '하체': { front: ['leg-l', 'leg-r', 'calf-l', 'calf-r', 'hip'], back: ['leg-l', 'leg-r', 'calf-l', 'calf-r', 'glute'] },
    '어깨': { front: ['shoulder-l', 'shoulder-r', 'arm-l', 'arm-r'], back: ['shoulder-l', 'shoulder-r', 'arm-l', 'arm-r'] },
    '전면삼각근': { front: ['shoulder-l', 'shoulder-r'], back: [] },
    '측면삼각근': { front: ['shoulder-l', 'shoulder-r'], back: ['shoulder-l', 'shoulder-r'] },
    '후면삼각근': { front: [], back: ['shoulder-l', 'shoulder-r', 'upper-back'] },
    '이두': { front: ['arm-l', 'arm-r'], back: [] },
    '삼두': { front: [], back: ['arm-l', 'arm-r'] },
    '전완근': { front: ['arm-l', 'arm-r'], back: ['arm-l', 'arm-r'] },
    '대퇴사두근': { front: ['leg-l', 'leg-r'], back: [] },
    '햄스트링': { front: [], back: ['leg-l', 'leg-r'] },
    '둔근': { front: ['hip'], back: ['glute'] },
    '내전근': { front: ['leg-l', 'leg-r', 'hip'], back: ['leg-l', 'leg-r'] },
    '종아리': { front: ['calf-l', 'calf-r'], back: ['calf-l', 'calf-r'] },
    '복근': { front: ['abs'], back: [] },
    '상복부': { front: ['abs'], back: [] },
    '하복부': { front: ['abs', 'hip'], back: [] },
    '복사근': { front: ['abs'], back: ['lower-back'] },
    '코어': { front: ['abs', 'hip'], back: ['lower-back', 'glute'] },
    '전신': {
        front: ['chest', 'abs', 'hip', 'shoulder-l', 'shoulder-r', 'arm-l', 'arm-r', 'leg-l', 'leg-r', 'calf-l', 'calf-r'],
        back: ['upper-back', 'lower-back', 'glute', 'shoulder-l', 'shoulder-r', 'arm-l', 'arm-r', 'leg-l', 'leg-r', 'calf-l', 'calf-r'],
    },
};

export default function BodyDiagram({ muscles }) {
    const frontSet = new Set((muscles || []).flatMap(m => MUSCLE_MAP[m]?.front || []));
    const backSet = new Set((muscles || []).flatMap(m => MUSCLE_MAP[m]?.back || []));

    const renderPart = (part, highlighted) => {
        const fill = highlighted ? 'var(--accent)' : 'var(--bg3)';
        const common = { key: part.key, fill, stroke: 'var(--bg2)', strokeWidth: 1, style: { transition: 'fill 0.25s' } };
        if (part.shape === 'ellipse')
            return <ellipse {...common} cx={part.cx} cy={part.cy} rx={part.rx} ry={part.ry} />;
        return <rect {...common} x={part.x} y={part.y} width={part.width} height={part.height} rx={part.rx || 0} />;
    };

    const renderView = (parts, set, label) => (
        <div style={{ textAlign: 'center' }}>
            <svg viewBox="0 0 64 132" style={{ width: 88, height: 'auto' }}>
                <circle cx={32} cy={10} r={9} fill="var(--bg3)" stroke="var(--bg2)" strokeWidth={1} />
                {parts.map(p => renderPart(p, set.has(p.key)))}
            </svg>
            <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 2 }}>{label}</div>
        </div>
    );

    return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 32, padding: '10px 0 4px' }}>
            {renderView(BODY_PARTS.front, frontSet, '앞')}
            {renderView(BODY_PARTS.back, backSet, '뒤')}
        </div>
    );
}
